import { PIEVE_MCP_ACTIONS_EXECUTE_TOOL_NAME, EXECUTE_VIRTUAL_ENV_TOOL_NAME, SUPPORTED_GENERATED_RESULT_FORMATS, THREAD_ARTIFACT_SURFACE } from './generatedFileArtifactContract.js';

const isGeneratedFileArtifactDescriptor = ({ artifact, toolName } = {}) => {
  const normalizedToolName = String(toolName || '')
    .trim()
    .toLowerCase();
  const normalizedSurface = String(artifact?.surface || '').trim();
  const normalizedResultFormat = String(artifact?.resultFormat || '')
    .trim()
    .toLowerCase();

  if (artifact?.producerSucceeded !== true || !String(artifact?.artifactId || '').trim() || normalizedSurface !== THREAD_ARTIFACT_SURFACE) {
    return false;
  }

  if (normalizedToolName === EXECUTE_VIRTUAL_ENV_TOOL_NAME) {
    return true;
  }

  const hasResultDisplay = Boolean(String(artifact?.resultDisplay?.type || '').trim());

  return normalizedToolName === PIEVE_MCP_ACTIONS_EXECUTE_TOOL_NAME && !hasResultDisplay && SUPPORTED_GENERATED_RESULT_FORMATS.includes(normalizedResultFormat);
};

export default isGeneratedFileArtifactDescriptor;
